import { render } from "./DetailedBilling.vue?vue&type=template&id=28d83a68&scoped=true"
import script from "./DetailedBilling.vue?vue&type=script&lang=js"
export * from "./DetailedBilling.vue?vue&type=script&lang=js"

import "./DetailedBilling.vue?vue&type=style&index=0&id=28d83a68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d83a68"]])

export default __exports__